import { Component,OnDestroy ,ElementRef, OnInit, ViewChild } from '@angular/core';
import { RfidService } from '../../../shared/services/rfid.service';
import {Login, LoginError, LoginSuccess, RfidLogin} from '@shared/store/auth/auth.actions';
import {AuthState} from '@shared/store/auth/auth.state';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ofActionCompleted } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import {Actions, Select, Store} from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { AuthService } from '@app/shared/services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslationService} from '@shared/services/translation.service';
import { MatDialog } from '@angular/material/dialog';
import {AssetService} from '@shared/services/asset.service';


@Component({
    selector: 'saf-rfid',
    templateUrl: './rfid.component.html',
    styleUrls: ['./rfid.component.scss'],
    standalone: false
})
export class RfidComponent implements OnInit,OnDestroy {

@Select(AuthState.loading) loading$:Observable<boolean>;

@ViewChild('rfidInput',{static:true}) rfidInput!:ElementRef<HTMLInputElement>;
  private rfidData:string='';
  private rfidTimeout:any;
  onDestroy$=new Subject<void>();
  private isAdmin=false;

  constructor(private rfidService: RfidService,
    private store: Store,
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private translationService: TranslationService,
    private AuthService: AuthService,
    private dialog: MatDialog,
    private assetService:AssetService,
  ) { }

  //handling rfid input and checking if its from scanner using pattern recognition 0-9
  onRFIDKeydown(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;
    const inputData = inputElement.value;

    console.log('Key pressed:', event.key); // Debug log

    if (event.key === 'Enter' && this.isRFIDInput(inputData)) {
      console.log('Valid RFID input detected:', inputData); // Debug log
      this.rfidService.setRFIDData(inputData);
      const rfidcode=(event.target as HTMLInputElement).value;

      //making ngrx integration call
      this.AuthService.rfid({rfidTag:rfidcode})
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        ({response,action})=>
        {


            this.store.dispatch(new RfidLogin({rfidTagSerial:rfidcode}));

        },
        (error)=>
        {
          this.onLoginError(error);
        }
      )


      inputElement.value = '';
    }
  }


private isRFIDInput(data:string):boolean
{
  return /^[A-Za-z0-9]{10,24}$/.test(data);
}


onLoginError({ error }) {
  this.snackBar.open(this.translationService.translate(error || 'loginIncorrect'));
}

onLoginSuccess(path :string) {

  const redirect=sessionStorage.getItem('redirect');

    sessionStorage.removeItem('redirect');


  this.store.dispatch(new Navigate([redirect||path]));
}
  ngOnInit() {

    this.rfidService.isFieldFocused$.subscribe(isFocused=>{
      if(isFocused && this.rfidInput?.nativeElement)
      {
        this.rfidInput?.nativeElement.focus();
      }
    });


    this.actions$.pipe(
      ofActionCompleted(LoginSuccess),
      takeUntil(this.onDestroy$),

    ).subscribe(({action})=>
    {
      const payload=(action as LoginSuccess).payload;
      console.log(payload);
      if(this.isAdmin=payload?.userDetails.user.systemUser===true)
      {
        this.onLoginSuccess('/employee');
      }else
      {
        this.onLoginSuccess('/');
      }
    });

    this.actions$.pipe(
      ofActionCompleted(LoginError),
      takeUntil(this.onDestroy$),
    ).subscribe(({action})=>this.onLoginError(action.payload));


  }


  ngAfterViewInit():void
  {
    this.focusRFIDInput();
  }
  private focusRFIDInput(): void {
    setTimeout(() => {
      const inputElement = this.rfidInput.nativeElement;
      if(document.activeElement!==inputElement)
      {
        inputElement.focus();
      }
      inputElement.style.opacity = '0';
      inputElement.style.position = 'absolute';
      inputElement.focus();

      console.log('RFID input is focused:', document.activeElement === inputElement); // Debug log
    }, 100);
  }

  ngOnDestroy()
  {

    this.onDestroy$.next();

  }

}
